import DisclaimerContainer from './TermsPrivacyContainer';

export default DisclaimerContainer;



// WEBPACK FOOTER //
// ./src/components/pages/components/ContentFooter/components/TermsPrivacy/index.js